import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  FormControlComponent,
  PrimengButtonDirective,
  PrimengInputTextDirective,
} from '@web/shared/ui';
import { InputTextModule } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { Nillable } from '@web/utils';

type PublicProductSearchPanelFormGroup = FormGroup<{
  phrase: FormControl<Nillable<string>>;
}>;

@Component({
  selector: 'app-public-product-search-panel',
  imports: [
    Button,
    FormControlComponent,
    InputTextModule,
    PrimengButtonDirective,
    PrimengInputTextDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './public-product-search-panel.component.html',
  styleUrl: './public-product-search-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductSearchPanelComponent {
  public readonly phraseChangeEvent = output<Nillable<string>>();

  protected readonly form = this.buildForm();

  public constructor(private readonly builder: FormBuilder) {}

  public handlePhraseChange(): void {
    const { phrase } = this.form.getRawValue();

    this.phraseChangeEvent.emit(phrase);
  }

  private buildForm(): PublicProductSearchPanelFormGroup {
    return this.builder.group({
      phrase: this.builder.control<Nillable<string>>(null),
    });
  }
}
